import request from "@/utils/request";

export function canSendRequest() {
  return request({
    url: "/ezamrequest/CanSendRequest",
    method: "post",
  });
}

export function SaveRequest(data) {
  return request({
    url: "/ezamrequest/Save",
    method: "post",
    data: data,
  });
}

export function getEzamRequestHistory() {
  return request({
    url: "/ezamrequest/GetHistory",
    method: "post",
  });
}

export function CancelRequest(id) {
  return request({
    url: "/ezamrequest/Cancel",
    method: "post",
    data: {
      Fserial: id
    }
  });
}
